import * as React from 'react';
import { useState } from 'react';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

export default function DateTimePickerValue() {
    const [selectedDate,setSelectedDate] = useState(new Date());
    return (
        <div>
            <DateTimePicker 
                amPmAriaLabel={true} 
                format={"y-MM-dd HH:mm:ss a"} 
                minDate={new Date()} 
                value={selectedDate} 
                onChange={date=>setSelectedDate(date)} 
            />
        </div>
    );
}